import { Box } from '@mui/material';

import DebenturesTable from './DebenturesTable';
import { QueryParams } from '..';
import { useAuthContext } from '../../../context/AuthContextProvider';

type DebenturesProps = {
  query: QueryParams;
  setQuery: (p: any) => void;
  handlePrint: () => void;
  handleModalOpen: () => void;
};

export default function Debentures({
  query,
  setQuery,
  handlePrint,
  handleModalOpen,
}: DebenturesProps) {
  const { auth }: any = useAuthContext();
  const hasPermission = Boolean(
    auth?.user?.subscription?.plan?.permissions?.operacoes_visao_basica,
  );

  return (
    <Box>
      <DebenturesTable
        query={query}
        setQuery={setQuery}
        hasPermission={hasPermission}
        isAuthLoading={Boolean(auth?.isLoading)}
        handlePrint={handlePrint}
        handleModalOpen={handleModalOpen}
      />
    </Box>
  );
}
